import { Card, Grid, Typography, Button4, useMediaQuery } from '@mui/material';
import { useTheme } from '@emotion/react';
import { ArcElement, Chart as ChartJS, Legend, Tooltip } from 'chart.js';
import { Pie } from 'react-chartjs-2';
import { fontsize15, poppins600 } from 'theme/common.style';
import { useCallback, useRef, useState, useEffect } from 'react';

ChartJS.register(ArcElement, Tooltip, Legend);
function PieChart({ sector2, list }) {
  const [fhb, setfhb] = useState(true);
  const [investor, setinvestor] = useState(true);
  const [UpSize, setupsize] = useState(true);
  const [downsize, setdownsize] = useState(true);
  const [Relocate, setrelocate] = useState(true);
  const [others, setothers] = useState(true);
  useEffect(() => {
    list?.length > 0 &&
      list?.map((item) => {
        if (item?.dataset == 'FHB') {
          if (item?.visible == true) {
            setfhb(true);
          } else {
            setfhb(false);
          }
        }
        if (item?.dataset == 'Investor') {
          if (item?.visible == true) {
            setinvestor(true);
          } else {
            setinvestor(false);
          }
        }
        if (item?.dataset == 'UpSize') {
          if (item?.visible == true) {
            setupsize(true);
          } else {
            setupsize(false);
          }
        }
        if (item?.dataset == 'DownSize') {
          if (item?.visible == true) {
            setdownsize(true);
          } else {
            setdownsize(false);
          }
        }
        if (item?.dataset == 'ReLocate') {
          if (item?.visible == true) {
            setrelocate(true);
          } else {
            setrelocate(false);
          }
        }
        if (item?.dataset == 'Others') {
          if (item?.visible == true) {
            setothers(true);
          } else {
            setothers(false);
          }
        }
      });
  }, [list]);

  const theme = useTheme();
  const matches500 = useMediaQuery(theme.breakpoints.down(500));

  const data = {
    labels: ['FHB', 'Investor', 'Relocate', 'UpSize', 'DownSize', 'Others'],
    datasets: [
      {
        label: 'Count',
        data: [
          fhb && sector2?.rightColumn?.FHB,
          investor && sector2?.rightColumn?.INV,
          Relocate && sector2?.rightColumn?.ReLoc,
          UpSize && sector2?.rightColumn?.UpSz,
          downsize && sector2?.rightColumn?.DwnSz,
          others && sector2?.rightColumn?.Others,
        ],
        backgroundColor: [
          'rgba(0, 119, 182,0.2)',
          'rgba(3, 4, 94, 0.2)',
          'rgba(144, 224, 239,0.2)',
          'rgba(153, 102, 255, 0.2)',
          'rgba(92, 124, 148, 0.2)',
          'rgba(0, 180, 216,0.2)',
        ],
        // fontSize: matches500 ? "8px" : undefined,
        borderColor: [
          'rgb(0, 119, 182)',
          'rgb(3, 4, 94)',
          'rgb(144, 224, 239)',
          'rgb(153, 102, 255)',
          'rgb(92, 124, 148)',
          'rgb(0, 180, 216)',
        ],
        borderRadius: '0px',
        borderWidth: 1,
      },
    ],
  };
  const options = {
    responsive: true,
    maintainAspectRatio: false,
  };

  const [downloadPieChart, setDownloadPieChart] = useState();
  let ref = useRef(null);

  // const DownloadImg = useCallback(() => {
  //   const link = document.createElement("a");
  //   link.download = "PieChart.png";
  //   link.href = ref.current.toBase64Image();
  //   setDownloadPieChart(ref.current.toBase64Image())
  // //   link.click();
  // })

  // useEffect(() => {
  //   DownloadImg();
  // }, [])

  return (
    <Grid
      style={{
        display: 'flex',
        paddingTop: '5px',
        alignItems: 'center',
        justifyContent: 'space-between',
        alignItems: 'center',
        minWidth: '100%',
        height: '100%',
      }}
    >
      <Card
        style={{
          borderRadius: '8px',
          padding: '15px',
          margin: '10px',
          height: '100%',
          boxShadow: 'none',
          minWidth: '98%',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'space-between',

          gap: '20px',
          backgroundColor: '#ffff',
        }}
      >
        <Grid item display={'flex'} justifyContent={'left'}>
          <Typography
            sx={{ ...poppins600, fontSize: matches500 ? '12px' : undefined }}
          >
            Demographic mapping
          </Typography>
        </Grid>
        {sector2?.rightColumn?.FHB == 0 &&
        sector2?.rightColumn?.INV == 0 &&
        sector2?.rightColumn?.ReLoc == 0 &&
        sector2?.rightColumn?.UpSz == 0 &&
        sector2?.rightColumn?.DwnSz == 0 &&
        sector2?.rightColumn?.Others == 0 ? (
          <Grid
            item
            sx={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              height: '250px',
            }}
          >
            <Typography sx={{ fontFamily: 'poppins' }}>
              No demographic data available
            </Typography>
          </Grid>
        ) : (
          <Grid
            item
            sx={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              height: '250px',
            }}
          >
            <Pie ref={ref} data={data} options={options}></Pie>
          </Grid>
        )}
      </Card>
    </Grid>
  );
}

export default PieChart;
